import { RootState } from "core-integration/src/store";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { getRegionsById } from "core-integration/src/store/regions/reducers";
import { useSelector } from "react-redux";
import CountryFlag from "../../CountryFlag";
import {
  entryName,
  entryTitleStyles,
  playerNameWrapper,
} from "./entryTitle.css";

interface PanelProps {
  entryId: number;
}

const EntryTitle = ({ entryId }: PanelProps) => {
  const entry = useSelector((state: RootState) => getEntry(state, entryId));
  const regionsById = useSelector(getRegionsById);
  const region = entry?.player_region_id
    ? regionsById[entry.player_region_id]
    : null;

  if (!entry) {
    return null;
  }

  return (
    <div className={entryTitleStyles}>
      <h2 className={entryName}>{entry.name}</h2>
      <div className={playerNameWrapper}>
        {entry.player_first_name} {entry.player_last_name}{" "}
        {region && <CountryFlag region={region} width="27px" height="18px" />}
      </div>
    </div>
  );
};

export default EntryTitle;
